import { render, staticRenderFns } from "./ProCompanyTimeline.vue?vue&type=template&id=0835d3c2&scoped=true"
import script from "./ProCompanyTimeline.vue?vue&type=script&lang=ts"
export * from "./ProCompanyTimeline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0835d3c2",
  null
  
)

export default component.exports